export default __webpack_public_path__ + "static/media/announcement-icon.8d410ede.svg";